import React from 'react';
import { Card } from './ui/Card';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'The educational approach was exactly what I needed. Instead of empty promises, I learned how to manage my utilization and build better habits.',
    author: 'Sarah M.',
    role: 'Small Business Owner'
  }, {
    quote: 'I finally understand how my credit profile works. The consultation was professional, transparent, and completely pressure-free.',
    author: 'James T.',
    role: 'Consulting Client'
  }, {
    quote: 'Brixen Credit taught me exactly what lenders look for when I was learning about the mortgage process. Highly recommended for the clarity alone.',
    author: 'Elena R.',
    role: 'Homebuyer'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-145">
      {testimonials.map((item, idx) => <Card key={idx} className="p-6 bg-slate-50 border-none" data-id="element-146">
          <div className="flex mb-4" data-id="element-147">
            {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-148" />)}
          </div>
          <p className="text-slate-700 italic mb-6 leading-relaxed" data-id="element-149">
            "{item.quote}"
          </p>
          <div data-id="element-150">
            <p className="font-semibold text-slate-900" data-id="element-151">{item.author}</p>
            <p className="text-sm text-slate-500" data-id="element-152">{item.role}</p>
          </div>
        </Card>)}
    </div>;
}